export const addCommas = (amount) => {
  if (amount === undefined || amount === null || isNaN(amount)) {
    return ""; // or return '0' or any other default value you prefer
  }
  // Convert the amount to a string and split into integer and decimal parts
  let parts = amount.toString().split(".");
  let integerPart = parts[0];
  let decimalPart = parts.length > 1 ? "." + parts[1] : "";
  if (integerPart === "0") {
    return "0" + decimalPart; // Return "0" or "0.00" etc.
  }

  // Add commas to the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine the integer and decimal parts
  return integerPart + decimalPart;
};

export const decodeBcNaming = (text = "") => {
  if (text == null) return "";
  return String(text)
    .replace(/_x000[0-9A-Fa-f]*_?/gi, " ")
    .replace(/_x[0-9A-Fa-f]{4}_/g, " ");
};

export const cleanSpecialNaming = (text = "") => {
  return decodeBcNaming(text).replace(/\s+/g, " ").trim();
};

export const base64ToBlob = (base64Data, fileExtension) => {
  let contentType = "";

  switch (fileExtension.toLowerCase()) {
    case "pdf":
      contentType = "application/pdf";
      break;
    case "txt":
      contentType = "text/plain";
      break;
    case "html":
      contentType = "text/html";
      break;
    case "json":
      contentType = "application/json";
      break;
    case "csv":
      contentType = "text/csv";
      break;
    case "jpg":
    case "jpeg":
      contentType = "image/jpeg";
      break;
    case "png":
      contentType = "image/png";
      break;
    case "gif":
      contentType = "image/gif";
      break;
    case "svg":
      contentType = "image/svg+xml";
      break;
    case "zip":
      contentType = "application/zip";
      break;
    case "doc":
      contentType = "application/msword";
      break;
    case "docx":
      contentType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      break;
    case "xls":
      contentType = "application/vnd.ms-excel";
      break;
    case "xlsx":
      contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      break;
    case "mp3":
      contentType = "audio/mpeg";
      break;
    case "mp4":
      contentType = "video/mp4";
      break;
    case "webm":
      contentType = "video/webm";
      break;
    case "ogg":
      contentType = "audio/ogg";
      break;
    default:
      contentType = "application/octet-stream"; // fallback for unknown types
      break;
  }

  // const byteCharacters = atob(base64WithoutPrefix);
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  // const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset++) {
    byteNumbers[offset] = byteCharacters.charCodeAt(offset);
  }

  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: contentType });
};

export const isInvalidDate = (dateValue) => {
  if (!dateValue) return true;
  // Check for various invalid date patterns
  return (
    dateValue.includes("0001-01-01") ||
    dateValue.includes("01/01/0001") ||
    dateValue.startsWith("0001-") ||
    new Date(dateValue).getFullYear() < 1900 // Consider dates before 1900 as invalid
  );
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

const BC_ATTACHMENT_TYPES = {
  Image: ["jpg", "jpeg", "png", "gif", "bmp", "webp", "tif", "tiff", "svg", "ico", "heic"],
  PDF: ["pdf"],
  Word: ["doc", "docx", "docm", "dot", "dotx", "rtf", "odt"],
  Excel: ["xls", "xlsx", "xlsm", "xlsb", "csv", "ods"],
  PowerPoint: ["ppt", "pptx", "pptm", "pps", "ppsx", "odp"],
  Email: ["msg", "eml"],
  XML: ["xml"],
};

export const mapBcAttachmentFileType = (fileName, mimeType = "") => {
  const ext = String(fileName || "").split(".").pop().toLowerCase();
  const mime = String(mimeType || "").toLowerCase();

  for (const [option, extensions] of Object.entries(BC_ATTACHMENT_TYPES)) {
    if (extensions.includes(ext)) return option;
  }

  if (mime.startsWith("image/")) return "Image";
  if (mime.includes("pdf")) return "PDF";
  if (mime.includes("word") || mime.includes("msword")) return "Word";
  if (mime.includes("excel") || mime.includes("spreadsheet")) return "Excel";
  if (mime.includes("powerpoint") || mime.includes("presentation")) return "PowerPoint";
  if (mime.includes("xml")) return "XML";
  if (mime.includes("message") || mime.includes("rfc822")) return "Email";

  return "Other";
};

export const getContentTypeFromBase64 = (base64String) => {
  const matches = base64String.match(/^data:(.+);base64,/);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return null;
};

export const parseApiError = (error) => {
  if (!error) return "An unexpected error occurred.";
  if (typeof error === "string") return error;

  const data = error.response?.data;
  const odataMessage = data?.error?.message;
  if (typeof odataMessage === "string" && odataMessage.trim()) {
    return odataMessage;
  }
  if (odataMessage?.value) return String(odataMessage.value);

  if (typeof data?.error === "string") return data.error;
  if (typeof data?.message === "string") return data.message;

  if (error.message && error.message !== "Request failed with status code 400") {
    return error.message;
  }

  return "The request failed. Check the values and try again.";
};
